import type { ClientInfo } from "@/shared/types";

/** How long ago an ISO time was, in the reader's language: "just now", "5 minutes ago",
    "yesterday". */
const MINUTE = 60_000;
const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ["day", 1_440 * MINUTE], ["hour", 60 * MINUTE], ["minute", MINUTE],
];
const relative = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });

export function ago(iso: string): string {
  const elapsed = Date.now() - new Date(iso).getTime();
  if (elapsed < MINUTE) return "just now";
  const [unit, span] = UNITS.find(([, ms]) => elapsed >= ms) ?? UNITS[UNITS.length - 1];
  return relative.format(-Math.round(elapsed / span), unit);
}

const UNKNOWN_ZONE = "Etc/Unknown"; // what ICU reports when the system's zone can't be read

/** Where the person is, sent with each message so the agent knows their date and time. A
    value the browser can't tell (no zone, or ICU's "Etc/Unknown") is left out: the server
    refuses a zone it doesn't know, and a send must never fail on it. */
export function clientInfo(): ClientInfo {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const locale = navigator.language;
  return {
    ...(timezone && timezone !== UNKNOWN_ZONE ? { timezone } : {}),
    ...(locale ? { locale } : {}),
  };
}
